import { useEffect, useState } from "react";

import { fetchQuery, graphql } from "relay-runtime";

import { environment } from "~/models";

import type { WillBeRecordedType } from "~/__generated__/CalendarPageQuery.graphql";
import type { WillBeRecordedNoCacheQuery } from "~/__generated__/WillBeRecordedNoCacheQuery.graphql";

const WillBeRecordedNoCacheQuery = graphql`
	query WillBeRecordedNoCacheQuery($eventGuid: String!) {
		eventByGuid(guid: $eventGuid) {
			willBeRecorded(noCache: true)
		}
	}
`;

/**
 * Hook that returns the willBeRecorded value for an event without using the willBeRecorded cache.
 * @param eventOrGuid - The event or guid of the event to check.
 * If it's an event, we will read the guid from it.
 * @returns The willBeRecorded value for the event.
 */
export function useWillBeRecordedNoCacheQuery(
	eventOrGuid: string | { guid?: string | null } | undefined | null,
): WillBeRecordedType {
	const [willBeRecorded, setWillBeRecorded] = useState<WillBeRecordedType>("UNKNOWN");
	const eventGuid = typeof eventOrGuid === "string" ? eventOrGuid : eventOrGuid?.guid;

	useEffect(() => {
		if (!eventGuid) {
			setWillBeRecorded("UNKNOWN");
			return;
		}

		fetchQuery<WillBeRecordedNoCacheQuery>(environment, WillBeRecordedNoCacheQuery, {
			eventGuid,
		})
			.toPromise()
			.then(result => {
				setWillBeRecorded(result?.eventByGuid?.willBeRecorded ?? "UNKNOWN");
			});
	}, [eventGuid]);

	return willBeRecorded;
}
